import AlarmCause from '@/config/form/widgets/AlarmCause';
import AlarmWay from '@/config/form/widgets/AlarmWay';
import AlarmContent from '@/config/form/widgets/AlarmContent';
import CarrierName from '@/config/form/widgets/CarrierName';
import { pPlatformUser } from '../../power/power';

/**
 * 注意事项:
 * 1.绑定到props时 一定要对组件进行Object.frezze  否则对性能有损耗
 * 2.因Es的import是浅拷贝 若要更改请进行一次拷贝后对默认值进行覆盖: { ...obj ,title: $t('integration.example')}
 * 3.此页面不允许写与业务逻辑相关内容
 */
/**
 * 字段说明:
 * index:<string[] | string> 后端返回的字段名  组件会自动匹配后端的字段值
 * title:<string> dialog标题
 * type:<'input' | 'select' | 'text'> 表单项的类型 【text-以文本显示(不允许修改) input-文本框 select-下拉选择】省略则默认为text
 * span:<number> 使用栅格布局 指定占用多少列 不填默认24列(一行)
 * dateType:<'time'> 数据的类型 暂只支持-time  若为time则会将时间戳自动转换日期时间格式
 * component:<Component> 为较复杂的表单项自定义一个组件 组件类型记得使用Object.freeze去除响应式 放在widgets目录下 可应对任意情况的数据
 * convert:<Object> 后端返回的值会自动与该Object的键相对应的title属性相匹配
 * selectOption: 当type为select时 下拉框的内容建议在convert.js内创建对应内容 在此页导入（仅用于前端写死的option,若是后端返回建议封装一个component以便复用）
 * required: 是否必填（必填则在侧边出现'*'）
 * rules:<FormItemRule[]> 该表单项对应的规则 可写在rule.js内 以便重用
 */

// 事务类型
export const fTransactionType = {
    index: 'transactionType',
    title: $t('integration.transaction_type'),
    type: 'text'
};

// 问题描述
export const fWorkOrderQuestionDesc = {
    index: 'description',
    type: 'text',
    title: $t('integration.problem_description'),
    span: 12
};

// 受理方式
export const fAcceptMethod = {
    inedx: 'method',
    type: 'select',
    title: $t('integration.acceptance_method'),
    span: 12
};

// 提交人
export const fSubmitter = {
    index: 'submitter',
    type: 'text',
    title: $t('integration.submitter'),
    span: 12
};

// 受理人
export const fAccpeter = {
    index: 'fAccpeter',
    type: 'text',
    title: $t('integration.acceptor'),
    span: 12
};

// 提交时间
export const fSubmitTime = {
    index: 'submitTime',
    title: $t('integration.submission_time'),
    type: 'text',
    span: 12,
    dataType: 'time'
};

// 受理时间
export const fAcceptTime = {
    index: 'acceptTime',
    title: $t('integration.acceptance_time'),
    type: 'text',
    span: 12,
    dataType: 'time'
};

// 客户
export const fCustomer = {
    index: 'sceneName',
    title: $t('integration.customer'),
    hidden: pPlatformUser
};

// 组织单元
export const fScene = {
    index: 'fullStructurePath',
    title: $t('integration.organizational_unit')
};

// 挂载 | 监测点
export const fCarrier = {
    index: 'carrierName',
    title: $t('integration.monitoring_point'),
    component: CarrierName
};

// 报警原因
export const fAlarmCause = {
    index: 'alarmReason',
    title: $t('integration.alarm_reason'),
    component: AlarmCause
};

// 报警层级
export const fAlarmLayer = {
    index: 'hierarchy',
    title: $t('integration.alarm_level')
};

// 报警对象
export const fAlarmObject = {
    index: 'alarmObject',
    title: $t('integration.alarm_object')
};

// 报警方式
export const fAlarmWay = {
    index: 'alarmWay',
    title: $t('integration.alarm_mode'),
    component: AlarmWay
};

// 手机号码
export const fPhone = {
    index: 'mobile',
    title: $t('integration.phone_number')
};

// 电子邮箱
export const fEmail = {
    index: 'email',
    title: $t('integration.e-mail')
};

// 报警事件
export const fAlarmTime = {
    title: $t('integration.alarm_time'),
    index: 'alarmTime',
    dataType: 'time'
};

// 报警内容
export const fAlarmContent = {
    title: $t('integration.alarm_content'),
    index: 'alarmContent',
    component: AlarmContent
};
